import axios from 'axios'
import { Message } from 'element-ui'
import { removeUser } from './auth'

//创建axios实例
const service = axios.create({
    baseURL: 'http://42.96.153.211:2923/',
    //baseURL: 'http://localhost:2923/',
    timeout: 60000, //请求超时时间
    withCredentials: true
})

//http request拦截器   
service.interceptors.request.use(
    config => {
        // if(store.getters.token){
        //     config.headers['X-Token'] = getToken() // 让每个请求携带token--['X-Token']为自定义key 根据实际情况自行修改
        // }
        config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
        return config
    },
    error => {
        //console.log('error:' + error) //控制台打印错误信息
        return Promise.reject(error)
    }
)

//http response拦截器
service.interceptors.response.use(
    response => {
        /**
         * code != 20000 是后台服务器响应抛出的错误
         */
        const res = response.data
        if(res.code != 20000){
            Message({
                type: 'error',
                message: res.message,
                duration: 5 * 1000
            })

            if(res.code == 20002){
                removeUser()
                window.location.href = '/login'
                return
            }
           
        }
    
        return res
    },
    error => {
        //console.log('error:' + error) //控制台打印错误信息
        // Message({
        //     type: 'error',
        //     message: error.data,
        //     duration: 5 * 1000, //错误信息提示的持续时间
        // })
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js